module.exports = __webpack_public_path__ + "static/media/calendar-without-header.6589b64b.png";